/**
 * Sends width and length images to the backend for multi-room prediction.
 * @param {File} widthImageFile - Image file for width
 * @param {File} lengthImageFile - Image file for length
 * @param {boolean} shareWithContractor - whether to trigger contractor alerts
 * @returns {Promise<Object>} - Parsed prediction result from backend
 */

import { auth } from "../services/firebase";
import API_BASE from "./apiBase";

export async function fetchMultiRoomPrediction(
  widthImageFile,
  lengthImageFile,
  shareWithContractor = false
) {

  if (!widthImageFile || !lengthImageFile) {
    throw new Error(
      "fetchMultiRoomPrediction: both width and length images are required."
    );
  }

  const formData = new FormData();

  // --------------------------------------------------
  // IMPORTANT: fields must be appended BEFORE files
  // (multer reads fields in order)
  // --------------------------------------------------

  formData.append(
    "sharedWithContractor",
    shareWithContractor ? "true" : "false"
  );

  // attach user identity
  if (auth.currentUser) {
    formData.append("userEmail", auth.currentUser.email);
    formData.append("userId", auth.currentUser.uid);
  }

  // --------------------------------------------------
  // Attach images
  // --------------------------------------------------

  formData.append("widthImage", widthImageFile);
  formData.append("lengthImage", lengthImageFile);

  const url = `${API_BASE}/api/multiRoomPredict`;

  console.log("MultiRoom API endpoint:", url);
  console.log("Shared with contractor:", shareWithContractor);

  try {

    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => "");
      throw new Error(
        `Prediction failed (${response.status}): ${
          errorText || response.statusText
        }`
      );
    }

    const result = await response.json();

    console.log("✅ MultiRoom prediction API response:", result);

    return result;

  } catch (error) {

    console.error("❌ Error in fetchMultiRoomPrediction:", error);

    throw error;

  }
}
